import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f19a64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-justify-content-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", { class: "progress is-primary" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-content-center"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-5 has-text-centered\" data-v-5f19a64c><span class=\"fa fa-times has-text-danger fa-6x\" data-v-5f19a64c></span></div><p class=\"is-size-5 has-text-centered\" data-v-5f19a64c> There was a problema validating your payment. </p><p class=\"has-text-grey has-text-centered\" data-v-5f19a64c> Contact our support at <a href=\"mailto:support@vetexpertise.com\" data-v-5f19a64c>support@vetexpertise.com</a></p>", 3)
const _hoisted_13 = [
  _hoisted_10
]
const _hoisted_14 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check has-text-success fa-6x" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "mt-5 has-text-centered"
}
const _hoisted_18 = { class: "is-size-3" }
const _hoisted_19 = { class: "is-size-5" }
const _hoisted_20 = { class: "has-text-grey" }

import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";



const __default__ = {
  name: "RequestSent",
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const store = useStore()
const paymentHash = ref()
const validating = ref(true)
const hasError = ref(false)

onMounted(async () => {
  paymentHash.value = route.params.payment_hash

  /* validate payment */
  try {
    // payment disabled
    const validated = true
    // const validated = await store.dispatch('confirmPayment', paymentHash.value)

    /* turn off validation state */
    if (validated) {
      validating.value = false
    }

  } catch (e) {
    hasError.value = true
  }


})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (validating.value && !hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.waitAMomentPlease')), 1),
                  _hoisted_8
                ]))
              : _createCommentVNode("", true),
            (hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('message.thankYou')), 1),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('message.yourRequestHasBeenSent')), 1),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('message.weWillConfirmAsSoonAsPossibleAndSendEmail')), 1),
                  _createVNode(_component_router_link, {
                    class: "mt-4 button is-primary is-small",
                    to: "/"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.goBack')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})